/**
 * @module location 
 *  Apis must need auth details to trigger url - AuthApi
 */

 import store from '@/store/store';
 import Env from '@/env';
 import NormalApis from '@/Components/Controllers/NormalApis';
 
 
 export default {
     /**
      * Fetch all
      */
      locationPromotion(location_id) {
        const url= `${Env.promotion.url}/api/locationPromotion/${location_id}?onlyActive=true`; // new route
        return NormalApis.getApi(url,{
            api_token: Env.promotion.api_token
          })
            .then(res => res)
            .catch(err => err);
     },
 
 
 }